import { useTranslation } from '@hooks/useTranslation';
import { footer } from '@translations/translations';
import { useRouter } from 'next/router';

export default function LanguageSwitcher(): JSX.Element {
  const { push, locale } = useRouter();
  const { t } = useTranslation();

  const switchToLocale = async (locale: string): Promise<void> => {
    await fetch('/api/set-locale', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ locale }),
    });
    push('/', undefined, { locale });
  };

  return (
    <span
      className="cursor-pointer inline-block ml-4"
      onClick={() => switchToLocale(locale === 'en-US' ? 'de-DE' : 'en-US')}
    >
      {t(locale === 'en-US' ? footer.switchToGerman : footer.switchToEnglish)}
    </span>
  );
}
